import { extractNames, analyzeCategory, analyzeSentiment } from './textAnalysis';

export const createNewMessage = (inputText) => {
  const names = extractNames(inputText);
  
  let processedText = inputText;
  names.forEach(properName => {
    const nameRegex = new RegExp(`\\b${properName}\\b`, 'gi');
    processedText = processedText.replace(nameRegex, properName);
  });

  return {
    id: Date.now(),
    text: processedText,
    timestamp: new Date(),
    names: names,
    category: analyzeCategory(processedText),
    sentiment: analyzeSentiment(processedText),
    note: null,
    attachment: null
  };
};